export default __webpack_public_path__ + "static/media/contact3.b352abb6.png";